import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import store from './store';
import isAuthenticated from '../util/isAuthenticated';

const ProtectedRoute = ({ component: Component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={(props) => {
				console.log(store.getState());
				if (isAuthenticated()) {
					return <Component {...props} />;
				} else {
					return (
						<Redirect
							to={{
								pathname: '/login',
								state: {
									from: props.location,
								},
							}}
						/>
					);
				}
			}}
		/>
	);
};
export default ProtectedRoute;
